<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Aplikacija T-2 TV za Smart TV
          </p>
          <div v-if="seznamVsehPrikljuckov.length > 1" style="padding-top: 20px">
            <p>
              Izbrani priključek
              <IzbirnikPrikljuckaSelect
                style-class="izbirnik-prikljuckov"
                @novIzbranPrikljucek="izbranPrikljucek = $event"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
              />
            </p>
          </div>
          <div class="odmik-smart-tv" v-if="podatkiPrikljucka !== null">
            <div class="prikaz-desktop">
              <div>
                <p class="navadno-besedilo">
                  <span v-if="trenutniPrikljucekJePrepaid">
                    Z aplikacijo <b>T-2 TV</b> lahko spremljate televizijske storitve T-2 na pametnih televizorjih in drugih napravah, brez dodatne opreme.
                  </span>
                  <span v-else>
                    Z aplikacijo <b>T-2 TV</b> lahko spremljate televizijske storitve T-2 na pametnih televizorjih in drugih napravah prek domačega priključka, brez dodatne opreme.
                  </span>
                </p>
              </div>
              <div style="padding-top: 10px" v-if="!izjemeSmartTv.includes(izbranPrikljucek)">
                <p class="navadno-besedilo" v-if="trenutniPrikljucekJePrepaid">
                  Aktivacija je enostavna – s klikom na gumb <b>AKTIVIRAJ T-2 TV</b> se odpre okno za vpis kode, ki se prikaže
                  ob prvem zagonu aplikacije. Po vpisu kode aplikacijo T-2 TV registrirate s klikom na gumb DODAJ NAPRAVO.
                </p>
                <p v-else>
                  Aktivacija je preprosta – s klikom na gumb <b>AKTIVIRAJ T-2 TV</b> izvedete naročilo, nato pa v zadnjem
                  koraku vnesete kodo, ki se prikaže ob prvem zagonu aplikacije.
                </p>
              </div>
              <div style="padding-top: 10px" v-if="smartTvData !== null && !izjemeSmartTv.includes(izbranPrikljucek) && !trenutniPrikljucekJePrepaid">
                <p class="navadno-besedilo">
                  Za uporabo aplikacije je potrebna naročnina na IPTV. Če je še nimate, se ob naročilu aplikacije
                  naročita obe storitvi hkrati. Cena naročila aplikacije za posamezno napravo znaša
                  <b>{{ smartTvData.cena }} €</b> na mesec.
                </p>
                <p class="navadno-besedilo">
                  V primeru, da vaš paket že vključuje naročnino na aplikacijo T-2 TV, je potrebno le registrirati napravo.
                  Hkrati je lahko registriranih do 5 naprav.
                </p>
              </div>
              <div style="padding-top: 10px" v-if="!trenutniPrikljucekJePrepaid">
                <p class="navadno-besedilo">
                  Več o aplikaciji si lahko preberete na
                  <a :href="tvAplikacija" class="primarna-barva">
                    https://www.t-2.net/aplikacija-t-2-tv
                  </a>.
                </p>
              </div>
            </div>
          </div>
          <div class="prikaz-mobile">
            <el-collapse accordion>
              <p class="navadno-besedilo">
                  <span v-if="trenutniPrikljucekJePrepaid">
                    Z aplikacijo <b>T-2 TV</b> lahko spremljate televizijske storitve T-2 na pametnih televizorjih in drugih napravah, brez dodatne opreme.
                  </span>
                <span v-else>
                    Z aplikacijo <b>T-2 TV</b> lahko spremljate televizijske storitve T-2 na pametnih televizorjih in drugih napravah prek domačega priključka, brez dodatne opreme.
                  </span>
              </p>
              <el-collapse-item title="Več o aplikaciji" name="1">
                <div v-if="podatkiPrikljucka !== null">
                  <div style="padding-top: 10px; color: #111820;" v-if="!izjemeSmartTv.includes(izbranPrikljucek)">
                    <p class="navadno-besedilo" v-if="trenutniPrikljucekJePrepaid">
                      Aktivacija je enostavna – s klikom na gumb <b>AKTIVIRAJ T-2 TV</b> se odpre okno za vpis kode, ki se prikaže
                      ob prvem zagonu aplikacije. Po vpisu kode aplikacijo T-2 TV registrirate s klikom na gumb DODAJ NAPRAVO.
                    </p>
                    <p v-else>
                      Aktivacija je preprosta – s klikom na gumb <b>AKTIVIRAJ T-2 TV</b> izvedete naročilo, nato pa v zadnjem
                      koraku vnesete kodo, ki se prikaže ob prvem zagonu aplikacije.
                    </p>
                  </div>
                  <div style="padding-top: 10px" v-if="smartTvData !== null && izjemeSmartTv.includes(izbranPrikljucek) && !trenutniPrikljucekJePrepaid">
                    <p class="navadno-besedilo">
                      Za uporabo aplikacije je potrebna naročnina na IPTV. Če je še nimate, se ob naročilu aplikacije
                      naročita obe storitvi hkrati. Cena naročila aplikacije za posamezno napravo znaša
                      <b>{{ smartTvData.cena }} €</b> na mesec.
                    </p>
                    <p class="navadno-besedilo">
                      V primeru, da vaš paket že vključuje naročnino na aplikacijo T-2 TV, je potrebno le registrirati napravo.
                      Hkrati je lahko registriranih do 5 naprav.
                    </p>
                  </div>
                  <div style="padding-top: 10px" v-if="!trenutniPrikljucekJePrepaid">
                    <p class="navadno-besedilo">
                      Več o aplikaciji si lahko preberete na
                      <a :href="tvAplikacija" class="primarna-barva">
                        https://www.t-2.net/aplikacija-t-2-tv
                      </a>.
                    </p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div v-if="seznamVsehPrikljuckov.length > 0">
            <div class="form-group" style="padding-top: 30px;" v-if="seznamSmartTv.length <= this.maxKolicina && showAddDevice">
              <div>
                <el-input placeholder="Vpišite kodo" v-model="idSmartTvZaDodat" class="velikost-input">
                </el-input>
              </div>
              <div class="odmik-gumb">
                <el-button type="primary" @click="DodajSmartTv" class="gumb-potrdi">
                  DODAJ NAPRAVO
                </el-button>
              </div>
            </div>
            <template v-if="!showAddDevice">
              <el-button
                :disabled="seznamSmartTv.length >= this.maxKolicina"
                type="primary"
                @click="checkIfHasToSignDocs()"
                class="gumb-potrdi mt-6"
              >
                AKTIVIRAJ T-2 TV
              </el-button>
            </template>
            <div style="padding-top: 20px;" v-if="seznamSmartTv.length > 0 && !pridobivanjeSmartTv
              && seznamSmartTv.length <= this.maxKolicina">
              <hr class="hr-stil"/>
            </div>
            <div style="padding-top: 30px">
              <div v-if="seznamSmartTv.length > 0 && !pridobivanjeSmartTv">
                <p class="open-sans-20pt">
                  Dodane naprave
                </p>
                <div v-show="prikazTabele === '1'">
                  <el-table :data="seznamSmartTv" v-loading="pridobivanjeSmartTv">
                    <el-table-column prop="deviceName"
                                     label="Ime naprave">
                    </el-table-column>
                    <el-table-column prop="deviceType"
                                     label="Tip naprave">
                    </el-table-column>
                    <el-table-column prop="lastIp"
                                     label="Zadnji IP naslov">
                    </el-table-column>
                    <el-table-column prop="zadnjaUporabaDatum"
                                     label="Zadnja uporaba">
                    </el-table-column>
                    <el-table-column class-name="poravnano-centralno">
                      <template slot-scope="scope">
                        <order-button
                          v-if="hasToSignDocsForRemove && !izjemeSmartTv.includes(izbranPrikljucek)"
                          :service-name="`Smart TV za napravo ${scope.row.deviceName}`"
                          :services="[
                            {
                              serviceId: StoritevEnum.APLIKACIJA_T2_TV,
                              quantity: 0,
                              terminationPointId: Number.parseInt(izbranPrikljucek),
                              additionalData: [
                                {
                                  key: 'removeDeviceId',
                                  value: scope.row.id.toString()
                                }
                              ]
                            }
                          ]"
                          @orderConfirmed="reloadDataOnServiceChange()"
                        >
                          <template v-slot:buttonOverride>
                            <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer"
                                 class="odstrani-napravo">
                            ODJAVA APLIKACIJE
                          </template>
                        </order-button>
                        <a v-else class="open-sans-13pt" style="cursor: pointer"
                           @click="OdstraniSmartTv(scope.row.id)">
                          <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer"
                               class="odstrani-napravo">
                          <span>
                            ODJAVA APLIKACIJE
                          </span>
                        </a>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-show="prikazTabele === '0'">
                  <el-table
                    :data="seznamSmartTv"
                    :expand-row-keys="expandRowKeys"
                    :row-key="row => row.guid"
                    @expand-change="IzbiraVrsticeZaPregledDodanihNaprav">
                    <el-table-column prop="deviceName"
                                     label="Ime naprave">
                    </el-table-column>
                    <el-table-column type="expand">
                      <template slot-scope="scope">
                        <div class="padding-table-phone">
                          <p>
                          <span>
                            <b>
                              Ime naprave:
                            </b>
                          </span>
                            {{ scope.row.deviceName }}
                          </p>
                          <p>
                          <span>
                            <b>
                              Tip naprave:
                            </b>
                          </span>
                            {{ scope.row.deviceType }}
                          </p>
                          <p>
                          <span>
                            <b>
                              Zadnji IP naslov:
                            </b>
                          </span>
                            {{ scope.row.lastIp }}
                          </p>
                          <p>
                          <span>
                            <b>
                              Zadnja uporaba:
                            </b>
                          </span>
                            {{ scope.row.zadnjaUporabaDatum }}
                          </p>
                          <span class="postavitev-tab-phone">
                            <order-button
                              v-if="hasToSignDocsForRemove"
                              :service-name="`Smart TV za napravo ${scope.row.deviceName}`"
                              :services="[
                                {
                                  serviceId: StoritevEnum.APLIKACIJA_T2_TV,
                                  quantity: 0,
                                  terminationPointId: Number.parseInt(izbranPrikljucek),
                                  additionalData: [
                                    {
                                      key: 'removeDeviceId',
                                      value: scope.row.id.toString()
                                    }
                                  ]
                                }
                              ]"
                              @orderConfirmed="reloadDataOnServiceChange()"
                            >
                              <template v-slot:buttonOverride>
                                <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer"
                                     class="odstrani-napravo">
                                ODJAVA APLIKACIJE
                              </template>
                            </order-button>
                            <a v-else class="open-sans-13pt" style="cursor: pointer" @click="OdstraniSmartTv(scope.row.id)">
                              <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer"
                                   class="odstrani-napravo">
                              <span style="padding-top: 6px">
                                ODJAVA APLIKACIJE
                              </span>
                            </a>
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div v-if="seznamVsehPrikljuckov.length === 0 && !pridobivanjePodatkov">
            <div class="obvestilo-prazen-seznam">
              <p>
                Nimate priključka, ki bi omogočil naročilo.
              </p>
            </div>
          </div>
          <div class="postavitev-info">
            <div class="info-okvir">
              <div class="postavitev-info-icone">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="postavitev-info-tekst">
                <p class="modra-barva-info">
                  Aplikacija T-2 TV je na voljo za vse priljubljene znamke pametnih televizorjev in naprav, vključno z
                  napravami z operacijskim sistemom Android TV, Philips Saphi in Titan, Samsung Tizen, Amazon Fire TV,
                  Apple TV, LG webOS ter VIDAA Smart OS. Celoten seznam podprtih naprav je na voljo
                  <a class="modra-barva-info"
                     :href="seznamnaprav" style="text-decoration: underline">
                    tukaj</a>.
                </p>
              </div>
              <br style="line-height: 0; height: 0; clear: both"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      append-to-body
      :visible.sync="dialogVisibleDodajNapravo"
      :width="'530px'"
      :show-close="false"
      center
      custom-class="smartTvAktivacijaNotification"
    >
      <span>
        <div>
          <div class="postevitev-title-img">
            <img src="/static/img/MojProfil/Icon-feather-check.png" style="cursor: pointer">
          </div>
        </div>
        <div style="padding: 50px 40px 0 40px;">
          <div>
            <p style="word-break: break-word; text-align: center; font-size: 15px">
              Uspešno ste aktivirali aplikacijo T-2 TV.
            </p>
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="gumb-brez-obrob krepko crna" @click="dialogVisibleDodajNapravo = false">
          Zapri
        </el-button>
      </span>
    </el-dialog>
    <order-button
      v-if="popupSpremembaStoritev"
      :open-popup-directly="true"
      :services="[{serviceId: StoritevEnum.APLIKACIJA_T2_TV, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
      :serviceName="'Aplikacija T-2 TV'"
      @orderConfirmed="reloadDataOnServiceChange()"
      @orderCanceled="orderCanceled()"
      @popupClosed="orderCanceled()"
    />
  </div>
</template>
<script>
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import Vue from 'vue'
import {
  Table,
  TableColumn,
  Input,
  Button,
  Form,
  FormItem,
  Select,
  Option,
  Collapse,
  CollapseItem,
  MessageBox,
  Dialog
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import IzbirnikPrikljuckov from '../../GlobalneKomponente/IzbirnikPrikljuckov.vue'
import {
  PridobivanjeStoritevSmarTv
} from '../../../../../assets/js/globalne_funkcije/NarociTelevizija/NaborStoritevTvSmart'
import IzbirnikStranke from '../../GlobalneKomponente/IzbirnikStranke.vue'
import IzbirnikPrikljuckaSelect from '../../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {UrejenSeznamPrikljuckov} from '../../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import SpremembaStoritevPopup from '../SpremembaStoritevPopup.vue'
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import Storitve from '../../../../../assets/js/Storitve/Storitve'
import {StoritevVrstaEnum} from '../../../../../assets/js/Enum/StoritevVrstaEnum'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
Vue.use(Form)
Vue.use(FormItem)
export default {
  computed: {
    StoritevEnum () {
      return StoritevEnum
    },
    hasToSignDocsForRemove () {
      return Array.isArray(this.seznamSmartTv) && this.seznamSmartTv.length > this.stBrezplacnih
    },
    trenutniPrikljucekJePrepaid () {
      return (
        this.izbranPrikljucek !== null &&
        this.prepaidPrikljucki !== null &&
        this.prepaidPrikljucki.indexOf(Number.parseInt(this.izbranPrikljucek)) !== -1
      )
    }
  },
  mixins: [PrikazVsebine, PridobivanjeStoritevSmarTv, FormatDatuma],
  name: 'SmartTv',
  components: {
    OrderButton,
    SpremembaStoritevPopup,
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    PridobivanjeStoritevSmarTv,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Dialog.name]: Dialog
  },
  data () {
    return {
      accessToken: '',
      dovoljenja: {},
      seznamPrikljuckov: [],
      seznamSmartTv: [],
      seznamTV: [],
      idSmartTvZaDodat: '',
      tvAplikacija: '',
      seznamnaprav: '',
      pridobivanjeSmartTv: false,
      expandRowKeys: [],
      mejnaSirinaTabela: 1000,
      prikazTabele: '1',
      izbranPrikljucek: null,
      smartTvData: null,
      seznamZaporednihKlicev: [],
      selectorPermissions: ['NASTAVITVE_TELEVIZIJA'],
      seznamVsehPrikljuckov: [],
      pridobivanjePodatkov: true,
      podatkiPrikljucka: null,
      seznamPrikljuckovOtt: [],
      dialogVisibleDodajNapravo: false,
      splosniPogojiURL: '',
      imaTvNarocnino: false,
      seznamPrikljuckovGrupirano: [],
      showAddDevice: false,
      popupSpremembaStoritev: false,
      maxKolicina: 0,
      storitve: null,
      stBrezplacnih: null,
      prepaidPrikljucki: null,
      izjemeSmartTv: ['1647810', '1043438', '24289', '1525700', '655427', '838184', '1070991', '836040', '1313209', '1525700', '185031', '432186', '432190', '438277', '873777']
    }
  },
  watch: {
    async izbranPrikljucek (val) {
      this.storitve = new Storitve([StoritevVrstaEnum.NAROCNINA_ZUNANJE_NAPRAVE], this.izbranPrikljucek)
      await this.reloadServices()
      if (val) {
        this.showAddDevice = false
        this.GetSmartTvInfo()
        this.GetKolicinaSmartTv()
        this.KlicGlobalneMetodeStoritveSmartTv() // samo zato, da pridobimo ceno, da se nafila smartTvData
        for (let i = 0; i < this.seznamVsehPrikljuckov.length; i++) {
          if (val === this.seznamVsehPrikljuckov[i].id_prikljucek) {
            this.podatkiPrikljucka = this.seznamVsehPrikljuckov[i]
          }
        }
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.tvAplikacija = povezave.BASE_URL_APLIKACIJA_TV
    this.seznamnaprav = povezave.BASE_URL_SEZNAM_NAPRAV
    this.splosniPogojiURL = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    this.loadPrepaidPrikljucki()
  },
  methods: {
    async loadPrepaidPrikljucki () {
      try {
        let pot = 'permissions/havePermission'
        let params = {permissionId: 'PREPAID_PRIKLJUCKI'}
        let response = await this.clientAgent.makeRequest(pot, params, 'POST')
        this.prepaidPrikljucki = response.permission.results
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    orderCanceled () {
      this.popupSpremembaStoritev = false
    },
    async reloadDataOnServiceChange () {
      this.popupSpremembaStoritev = false
      this.GetSmartTvInfo()
      this.GetKolicinaSmartTv()
    },
    async reloadServices (override = false) {
      try {
        await this.storitve.loadList(override)
      } catch (e) {
        this.ErrPrikljuckiDovoljenja(e)
      }
    },
    checkIfHasToSignDocs () {
      if (!this.izjemeSmartTv.includes(this.izbranPrikljucek)) {
        if (
          Array.isArray(this.seznamSmartTv) &&
          this.seznamSmartTv.length >= this.stBrezplacnih &&
          this.seznamSmartTv.length < this.maxKolicina
        ) {
          this.popupSpremembaStoritev = true
        } else {
          this.showAddDevice = true
        }
      } else {
        this.showAddDevice = true
      }
    },
    KlicGlobalneMetodeStoritveSmartTv () {
      let param = {}
      param.vmesnik = this
      param.idPrikljucek = this.izbranPrikljucek
      this.GetStoritevSmartTv(param)
    },
    SetSmartTvData (podatki, smartTvData) {
      this.smartTvData = smartTvData
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja(podatkiStranke)
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissions[]=NASTAVITVE_TELEVIZIJA']
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.NASTAVITVE_TELEVIZIJA.additionalData.filter(x => x.tip_prikljucka !== 'UMTS')
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      if (this.seznamVsehPrikljuckov.length > 0) {
        this.izbranPrikljucek = this.seznamVsehPrikljuckov[0].id_prikljucek
        this.podatkiPrikljucka = this.seznamVsehPrikljuckov[0]
      }
      this.pridobivanjePodatkov = false
    },
    ErrPrikljuckiDovoljenja (podatki) {
      this.ShowWarningMessage(podatki)
    },
    IzbiraVrsticeZaPregledDodanihNaprav (row) {
      const id = row.guid
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetKolicinaSmartTv () {
      let param = ['subscriberId=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'fora/devices/getKolicinaSmartTv?',
        param,
        null,
        'SetKolicinaSmartTv',
        'ErrPrikljuckiDovoljenja')
    },
    SetKolicinaSmartTv (podatki) {
      this.maxKolicina = podatki.kolicina
      this.stBrezplacnih = podatki.stBrezplacnih
    },
    GetSmartTvInfo () {
      this.pridobivanjeSmartTv = true
      let param = ['subscriberId=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'fora/devices/info?',
        param,
        null,
        'SetSmartTvInfo',
        'ErrSmartTvInfo')
    },
    SetSmartTvInfo (podatki) {
      this.seznamSmartTv = podatki.data
      this.seznamSmartTv.forEach((device) => {
        if (device.lastActiveTime !== undefined) {
          let datum = new Date(Number(device.lastActiveTime))
          device.zadnjaUporabaDatum = this.PoenotenIzgledDatuma(datum)
        }
      })
      this.pridobivanjeSmartTv = false
    },
    ErrSmartTvInfo (podatki) {
      this.ShowWarningMessage(podatki)
      this.pridobivanjeSmartTv = false
    },
    DodajSmartTv () {
      let param = []
      param.push('subscriberId=' + this.izbranPrikljucek)
      param.push('authorisationToken=' + this.idSmartTvZaDodat)
      this.clientAgent.postWsRequest(
        this,
        'fora/devices/add',
        param,
        null,
        'SetDodajSmartTv',
        'ErrDodajSmartTv')
    },
    SetDodajSmartTv () {
      this.dialogVisibleDodajNapravo = true
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno dodan smart Tv.'
      this.GetSmartTvInfo()
      this.showAddDevice = false
      this.idSmartTvZaDodat = ''
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrDodajSmartTv (podatki) {
      this.ShowWarningMessage(podatki)
    },
    OdstraniSmartTv (idSmartTv) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite odstraniti napravo?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['subscriberId=' + this.izbranPrikljucek]
        param.push('deviceId=' + idSmartTv)
        this.clientAgent.postWsRequest(
          this,
          'fora/devices/remove',
          param,
          null,
          'SetOdstraniSmartTv',
          'ErrOdstraniSmartTv')
      }).catch((err) => {
        err = null
      })
    },
    SetOdstraniSmartTv () {
      this.GetSmartTvInfo()
      let paramObvestilo = {}
      paramObvestilo.message = 'Naprava je bila uspešno odstranjena.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrOdstraniSmartTv (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVsmart.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVsmart.vue